import { IonImg } from '@ionic/react';
import React from 'react';

import logo from '@/assets/images/logo/logo-with-icon.png';
import { Spacer } from '@/components/common';

import './Logo.css';

interface LogoProps {
  fixed?: boolean;
}

const Logo: React.FC<LogoProps> = ({ fixed = false }) => {
  const bloop = (e: React.MouseEvent<HTMLIonImgElement, MouseEvent>) => {
    const imageElement = e.currentTarget;
    if (imageElement.classList.contains('bloop')) {
      return;
    }
    imageElement.classList.add('bloop');
    setTimeout(() => {
      imageElement.classList.remove('bloop');
    }, 1000);
  };

  return (
    <>
      <div className={`logo ${fixed ? 'logo--fixed' : ''}`}>
        <IonImg src={logo} alt="Logo" className="logo__image" onClick={bloop} />
      </div>
      <Spacer bottom={66} />
    </>
  );
};

export default Logo;
